import {
    ADD_DISCOUNT_CODE_REQUESTED,
    ADD_DISCOUNT_CODE_SUCCESS,
    ADD_DISCOUNT_CODE_FAILED,
    DISCOUNT_CODES_REQUESTED,
    DISCOUNT_CODES_SUCCESS,
    DISCOUNT_CODES_FAILED,
    DELETE_DISCOUNT_CODE_REQUESTED,
    DELETE_DISCOUNT_CODE_SUCCESS,
    DELETE_DISCOUNT_CODE_FAILED,
} from './constants';
import { Action } from 'contexts/useReducerWithMiddleware';
import { PaginatedDiscountCodes } from 'types/DiscountCode';

export type DiscountCodeState = {
    loading: boolean;
    errorMessage: string;
    discountCodes: PaginatedDiscountCodes | null;
    operationLoading: boolean;
};

export const initialDiscountCodeState: DiscountCodeState = {
    loading: false,
    errorMessage: '',
    discountCodes: null,
    operationLoading: false,
};

export default function discountCodeReducer(state = initialDiscountCodeState, action: Action): DiscountCodeState {
    switch (action.type) {
        case DISCOUNT_CODES_REQUESTED:
            return {
                ...state,
                loading: true,
                errorMessage: '',
            };
        case DISCOUNT_CODES_SUCCESS:
            return {
                ...state,
                loading: false,
                errorMessage: '',
                discountCodes: (action.payload as { discountCode: PaginatedDiscountCodes }).discountCode,
            };
        case DISCOUNT_CODES_FAILED:
        case ADD_DISCOUNT_CODE_FAILED:
        case DELETE_DISCOUNT_CODE_FAILED:
            return {
                ...state,
                loading: false,
                operationLoading: false,
                errorMessage: (action.payload as { message: string }).message,
            };
        case ADD_DISCOUNT_CODE_REQUESTED:
        case DELETE_DISCOUNT_CODE_REQUESTED:
            return {
                ...state,
                operationLoading: true,
                errorMessage: '',
            };
        case ADD_DISCOUNT_CODE_SUCCESS:
        case DELETE_DISCOUNT_CODE_SUCCESS:
            return {
                ...state,
                operationLoading: false,
                errorMessage: '',
            };
        default:
            return state || initialDiscountCodeState;
    }
}
